import { Suspense } from "react"
import { Route, Routes } from "react-router-dom"
import { ThePoolzProvider } from "@poolzfinance/reacthelper"
import ScrollToTop from "components/ScrollUp/ScrollUp"
import BtnUp from "components/BtnUp/BtnUp"
import WalletModal from "components/WalletModal"
import { TimeWarning } from "components/Header/components/TimeWarning/TimeWarning"
import GlobalSnackbar from "components/GlobalSnackbar/GlobalSnackbar"
import { routes } from "./routes"
import ErrorBoundary from "components/ErrorBoundary/ErrorBoundary"
import API4Wrapper from "components/API4Wrapper/API4Wrapper"
import StrapiProvider from "@poolzfinance/strapi"

import Header from "components/Header/Header"
import Footer from "components/Footer/Footer"

export default function App() {
  return (
    <Suspense fallback={null}>
      <ThePoolzProvider>
        <ErrorBoundary>
          <StrapiProvider>
            <API4Wrapper>
              <ScrollToTop />
              <TimeWarning />
              <WalletModal />
              <GlobalSnackbar />
              <Routes>
                {routes.map((route) => (
                  <Route
                    key={route.path}
                    path={route.path}
                    element={
                      <>
                        <Header darkStyle={route.darkStyle} />
                        <div className="overflow-hidden flex-auto ">
                          <route.component />
                        </div>
                        <Footer darkStyle={route.darkStyle} />
                      </>
                    }
                  />
                ))}
              </Routes>
              <BtnUp />
            </API4Wrapper>
          </StrapiProvider>
        </ErrorBoundary>
      </ThePoolzProvider>
    </Suspense>
  )
}
